import type { FacetsDTO } from '@empathyco/playboard-core-domain'
import type { FacetsDomainService } from '../interfaces'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { injectable } from 'inversify'
import { FilterIdEnum } from '../../enums'
// @ts-strict-ignore
@injectable()
export class PlatformFacetsDomainService implements FacetsDomainService {
  getEmptyInstance(): FacetsDTO {
    return {
      id: undefined,
      metadata: {
        created: undefined,
        updated: undefined,
        author: undefined,
      },
      title: undefined,
      endpointId: undefined,
      criteria: {
        enabled: false,
        pivots: [],
        context: [
          {
            name: undefined,
            values: [],
          },
        ],
      },
      config: {
        enabled: false,
        context: undefined,
        facetableFields: {},
        facets: undefined,
        mainCollectionId: undefined,
        secondaryCollectionId: undefined,
      },
    }
  }

  isValid(instance: FacetsDTO): boolean {
    return (
      this.hasRequiredFields(instance) &&
      this.hasValidLanguageFilter(instance) &&
      this.hasValidContext(instance)
    )
  }

  private hasRequiredFields(instance: FacetsDTO): boolean {
    return !!(instance.title && instance.endpointId)
  }

  private hasValidLanguageFilter(instance: FacetsDTO): boolean {
    const { pivots } = instance.criteria
    if (!pivots) {
      return false
    }

    return pivots.some(pivot => pivot.name === FilterIdEnum.LANG && pivot.values.length > 0)
  }

  private hasValidContext(instance: FacetsDTO): boolean {
    const { context: configContext } = instance.config
    const { context: criteriaContext } = instance.criteria

    if (
      configContext === DomainEnum.SEARCH.toUpperCase() ||
      instance.endpointId === DomainEnum.SEARCH
    ) {
      return true
    }

    const firstContextValues = criteriaContext?.[0]?.values || []
    const secondContextValues = criteriaContext?.[1]?.values || []

    const firstContextEmpty = firstContextValues.length === 0
    const secondContextEmpty = secondContextValues.length === 0

    return (firstContextEmpty && secondContextEmpty) || (!firstContextEmpty && !secondContextEmpty)
  }
}
